module.exports = __webpack_public_path__ + "static/img/img_program_b.5ce3fe1b.png";